module.exports = __webpack_public_path__ + "static/media/image_huace.9c7c0155.png";